module.exports = __webpack_public_path__ + "img/Radness.e0d55cac.jpg";